// 应用常量
export const APP_CONFIG = {
    NAME: 'Text Game App',
    VERSION: '0.1.0',
    AUTHOR: 'Your Name',
    WEBSITE: 'https://your-website.com',
    SUPPORT_EMAIL: 'support@your-website.com',
};
// 存储键名
export const STORAGE_KEYS = {
    GAME_SCRIPTS: 'game_scripts',
    GAME_SESSIONS: 'game_sessions',
    SAVE_POINTS: 'save_points',
    APP_CONFIG: 'app_config',
    USER_PREFERENCES: 'user_preferences',
    RECENT_SCRIPTS: 'recent_scripts',
    RECENT_SESSIONS: 'recent_sessions',
    AI_MODEL_CONFIGS: 'ai_model_configs',
};
// 默认游戏设置
export const DEFAULT_GAME_SETTINGS = {
    aiModel: {
        provider: 'openai',
        model: 'gpt-4',
        temperature: 0.7,
        maxTokens: 2000,
        topP: 1,
        stream: true,
    },
    autoSave: true,
    autoSaveInterval: 5,
    showChoices: true,
    showStats: true,
    narrationStyle: 'second-person',
    difficulty: 'medium',
    language: 'en',
    theme: 'auto',
};
// 支持的AI模型提供商
export const AI_PROVIDERS = {
    OPENAI: {
        id: 'openai',
        name: 'OpenAI',
        models: [
            { id: 'gpt-4', name: 'GPT-4', maxTokens: 8192 },
            { id: 'gpt-4-turbo', name: 'GPT-4 Turbo', maxTokens: 128000 },
            { id: 'gpt-3.5-turbo', name: 'GPT-3.5 Turbo', maxTokens: 16385 },
        ],
        requiresApiKey: true,
    },
    ANTHROPIC: {
        id: 'anthropic',
        name: 'Anthropic',
        models: [
            { id: 'claude-3-5-sonnet-20241022', name: 'Claude 3.5 Sonnet', maxTokens: 200000 },
            { id: 'claude-3-haiku-20240307', name: 'Claude 3 Haiku', maxTokens: 200000 },
        ],
        requiresApiKey: true,
    },
    GOOGLE: {
        id: 'google',
        name: 'Google',
        models: [
            { id: 'gemini-pro', name: 'Gemini Pro', maxTokens: 30720 },
            { id: 'gemini-pro-vision', name: 'Gemini Pro Vision', maxTokens: 30720 },
        ],
        requiresApiKey: true,
    },
};
// 游戏难度设置
export const DIFFICULTY_SETTINGS = {
    easy: {
        aiTemperature: 0.5,
        showHints: true,
        autoSuggestActions: true,
        forgivingChoices: true,
    },
    medium: {
        aiTemperature: 0.7,
        showHints: false,
        autoSuggestActions: false,
        forgivingChoices: false,
    },
    hard: {
        aiTemperature: 0.9,
        showHints: false,
        autoSuggestActions: false,
        forgivingChoices: false,
        consequencesEnabled: true,
    },
};
// 剧本分类
export const SCRIPT_CATEGORIES = [
    'Adventure',
    'RPG',
    'Mystery',
    'Horror',
    'Romance',
    'Sci-Fi',
    'Fantasy',
    'Historical',
    'Comedy',
    'Drama',
    'Thriller',
    'Educational',
    'Other',
];
// 角色属性
export const CHARACTER_ATTRIBUTES = [
    'strength',
    'dexterity',
    'intelligence',
    'wisdom',
    'charisma',
    'constitution',
    'perception',
    'luck',
];
// 游戏状态标志
export const GAME_FLAGS = {
    TUTORIAL_COMPLETED: 'tutorial_completed',
    FIRST_CHOICE_MADE: 'first_choice_made',
    INVENTORY_OPENED: 'inventory_opened',
    CHARACTER_MET: 'character_met',
    QUEST_COMPLETED: 'quest_completed',
};
// UI相关常量
export const UI_CONSTANTS = {
    SIDEBAR_WIDTH: 280,
    HEADER_HEIGHT: 60,
    MESSAGE_MAX_LENGTH: 2000,
    SCRIPT_NAME_MAX_LENGTH: 100,
    SESSION_NAME_MAX_LENGTH: 100,
    SAVE_POINT_NAME_MAX_LENGTH: 50,
    MAX_RECENT_ITEMS: 10,
    AUTO_SAVE_DEBOUNCE_MS: 2000,
};
// Removed: keyboard shortcuts definition
// 文件类型和扩展名
export const FILE_TYPES = {
    SCRIPT: {
        extension: '.tgs',
        mimeType: 'application/json',
        description: 'Text Game Script',
    },
    SESSION: {
        extension: '.tgx',
        mimeType: 'application/json',
        description: 'Text Game Session Export',
    },
    SAVE: {
        extension: '.tgsave',
        mimeType: 'application/json',
        description: 'Text Game Save File',
    },
};
// 错误消息
export const ERROR_MESSAGES = {
    INVALID_API_KEY: 'Invalid API key. Please check your AI model configuration.',
    NETWORK_ERROR: 'Network error. Please check your internet connection.',
    SCRIPT_NOT_FOUND: 'Script not found. It may have been deleted.',
    SESSION_NOT_FOUND: 'Session not found. It may have been deleted.',
    SAVE_FAILED: 'Failed to save. Please try again.',
    LOAD_FAILED: 'Failed to load. The file may be corrupted.',
    INVALID_FILE_FORMAT: 'Invalid file format. Please select a valid file.',
    STORAGE_FULL: 'Storage is full. Please delete some files to free up space.',
};
